module.exports = __webpack_public_path__ + "media/ארנבת.1b301d5d.mp3";